import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["item"]
  static classes = ["filter", "effect"]
  static values = {
    threshold: Number,
    rootMargin: String,
  }

  connect() {
    this.threshold = this.thresholdValue || this.defaultOptions.threshold
    this.rootMargin = this.rootMarginValue || this.defaultOptions.rootMargin

    this.observer = new IntersectionObserver(
      entries => entries.forEach(({ intersectionRatio, target }) => {
        target.classList.toggle(this.filterClass, intersectionRatio < this.threshold)
        target.classList.toggle(this.effectClass, intersectionRatio < this.threshold)
      }),
      this.observerOptions
    )
    this.itemTargets.forEach(item => this.observer.observe(item))
  }

  disconnect() {
    this.itemTargets.forEach(item => this.observer.unobserve(item))
  }

  get observerOptions() {
    return {
      threshold: this.threshold,
      rootMargin: this.rootMargin
    }
  }

  get defaultOptions () {
    return {
      threshold: 1.0,
      rootMargin: '0px'
    }
  }
}
